import React from "react";
import InvoiceTable from "./components/InvoiceTable";

interface AdminInvoicePageProps {
  searchText?: string;
}

const AdminInvoicePage = ({
  searchText,
}: AdminInvoicePageProps): React.JSX.Element => {
  return <InvoiceTable searchText={searchText} />;
};

export default AdminInvoicePage;
